/*
 * @Author       : 蔡传明
 * @Date         : 2021-06-25 16:03:06
 * @LastEditors  : 蔡传明
 * @LastEditTime : 2021-09-13 10:25:17
 * @FilePath     : /club/src-client/index.tsx
 */
import React, { createContext, useContext } from 'react';
import * as ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { Main } from './container/Main';
import { AppContainer } from 'react-hot-loader';
import { Provider } from 'mobx-react';
import store from './model';
import HttpClient from '@chehejia/club-lib/lib/httpUtils/HttpClient';
import { ConfigProvider } from 'antd';
import toast from '@util/toast';
import zhCN from 'antd/lib/locale-provider/zh_CN';
import 'moment/locale/zh-cn';
// import { isAuthority } from './model/Login/Login';
import { refreshByToken } from './service/login/LoginService';
const clearAll = ()=>{
  localStorage.removeItem('img-id_token');
  localStorage.removeItem('img-access_token');
  localStorage.removeItem('img-refresh_token');

  localStorage.removeItem('artic-access_token');
  localStorage.removeItem('artic-id_token');
  localStorage.removeItem('artic-refresh_token');
  
  localStorage.removeItem('img-login_time')
  localStorage.removeItem('artic-login_time')
  localStorage.removeItem('img-expires_in');
  localStorage.removeItem('artic-expires_in');
  localStorage.removeItem('USERINFO');
  localStorage.removeItem('DEVICEID');
}
export class App {
    public constructor() {
        // const authority = new isAuthority()
        // authority.init().then(res => {
        //     if (Array.isArray(res.roles) && !res.roles.some(item => item === '文章发布')) {
        //         store.logout.init()
        //         window.location.href='/login';
        //     }
        // })

        HttpClient.interceptors.request(
            async request => {
                console.log('请求头', request.headers, request.url.indexOf('/icn-oas-api/v1'));
                // 除去部分接口，统一添加token请求头
                if (request.url.indexOf('/icn-oas-api/v1') === -1 && request.url.indexOf('?exif') === -1) {
                  request.headers.Authorization = `Bearer ${window.localStorage.getItem('artic-access_token')}`
                }
                // 判断当前请求发起时间和 接口过期时间
                try {
                    const nowTime = Number(new Date());
                    const artic_login_time = Number(
                        window.localStorage.getItem('artic-login_time')
                    );
                    const img_login_time = Number(
                      window.localStorage.getItem('img-login_time')
                  );
                    const articlTime = window.localStorage.getItem(
                        'artic-expires_in'
                    );
                    // 文章有效期时长（120s）
                    const numberArticlTime = articlTime
                        ? Number(articlTime)
                        : 0;
                    const imgTime = window.localStorage.getItem(
                        'img-expires_in'
                    );
                    // 图片有效期时长（300s）
                    const numberImgTime = imgTime ? Number(imgTime) : 0;
                    // 已登陆时长
                    const artic_lengTime = (nowTime - artic_login_time) / 1000;
                    const img_lengTime = (nowTime - img_login_time) / 1000;
                    // 登陆时长>有效期时长，刷新
                    if (artic_lengTime > numberArticlTime) {
                        await refreshByToken('artic');
                        window.localStorage.setItem(
                            'artic-login_time',
                            Number(new Date()) + ''
                        );
                        // 替换 如果是 artic
                        if (request.url.indexOf('/icn-oas-api/v1') === -1 && request.url.indexOf('?exif') === -1) {
                          request.headers.Authorization = `Bearer ${window.localStorage.getItem('artic-access_token')}`
                        }
                    }
                    if (img_lengTime > numberImgTime) {
                        await refreshByToken('img');
                        window.localStorage.setItem(
                            'img-login_time',
                            Number(new Date()) + ''
                        );
                        // 替换
                        // 替换 如果是 img
                        if (request.url.indexOf('/icn-oas-api/v1') !== -1) {
                          request.headers.Authorization = `Bearer ${window.localStorage.getItem('img-access_token')}`
                        }
                    }
                    return request;
                } catch (err) {
                    // 不在去请求需要重新登录
                    console.error(err, '不在去请求需要重新登录');
                    store.logout.init().then(() => {
                      clearAll()
                      window.location.href = '/login';
                      
                      store.hasLoginManage();
                  });
                }
            },
            err => {
                console.log(
                    err,
                    'HttpClient-------request-------interceptors--err'
                );
            }
        );
        HttpClient.interceptors.response(
            response => {
                if (response.data.success && response.data.code === 0) {
                    return response;
                }
                if (window.location.pathname !== '/login') {
                    /*  if (!response.data.success && response.data.code === 240102) {  // token无效
                     window.location.href = '/login';
                 } else if (!response.data.success && response.data.code === 240226) { // 用户token被挤掉
                     window.location.href = '/login';
                 } else if (!response.data.success && response.data.code === 240225) { // 用户token过期
                     window.location.href = '/login';
                 } else if (!response.data.success && response.data.code === 240224) { // 已经退出登录
                     window.location.href = '/login';
                 } */
                    if (
                        !response.data.success &&
                        response.data.code === 241000
                    ) {
                        // 没有权限
                        // toast.error('没有发布权限');
                        // // window.location.href='/login';
                        // // setTimeout(() => {
                        // //     store.logout.init().then(() => {
                        // //         store.hasLoginManage();
                        // //     });
                        // // }, 1000);
                        store.logout.init().then(() => {
                            window.location.href = '/login';
                            clearAll()
                            store.hasLoginManage();
                        });
                    }
                }

                return Promise.reject(response.data);
            },
            error => {
                console.error(error, 'response--error--interceptors');
                console.log('服务器开小差了!!!');
                // alert('网络错误');
                /*  if (window.location.pathname !== '/login') {
                 window.location.href = '/login';
             } */
                // window.location.href='/login';
                // clearAll()
                // return Promise.reject(error)
            }
        );
        window.addEventListener('offline', () => {
            toast.warning('您当前处于离线状态');
            setTimeout(() => {
                window.location.href = '/login';
            }, 3000);
            console.log('当前已经离线');
        });
        this.init();
    }

    private init() {
        // Sentry.init({
        //     dsn: 'https://2181ddece14f4e328a9edafd98202a22@sentry.lixiang.com/76',
        //     integrations: [new Integrations.BrowserTracing()],

        //     // Set tracesSampleRate to 1.0 to capture 100%
        //     // of transactions for performance monitoring.
        //     // We recommend adjusting this value in production
        //     tracesSampleRate: 1.0
        // });

        ReactDOM.render(
            <Provider store={store}>
                <AppContainer>
                    <ConfigProvider locale={zhCN}>
                        <Main />
                    </ConfigProvider>
                </AppContainer>
            </Provider>,
            document.getElementById('app')
        );
    }
}

new App();
